import { render, staticRenderFns } from "./psuConfirmForm.vue?vue&type=template&id=2da879db&scoped=true"
import script from "./psuConfirmForm.vue?vue&type=script&lang=js"
export * from "./psuConfirmForm.vue?vue&type=script&lang=js"
import style0 from "./psuConfirmForm.vue?vue&type=style&index=0&id=2da879db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da879db",
  null
  
)

export default component.exports